// extracted by mini-css-extract-plugin
export default {"gridServices":"active-services-overview_gridServices__-ZHlp","centeredCell":"active-services-overview_centeredCell__dVqcg"};